export default __webpack_public_path__ + "static/media/salle-dattente.3d912cdb.png";